import { useEffect, useState } from "react";
import { Product } from "../types/bomTypes";
import api from "../../../../../../features/auth/axiosConfig";

export const useCartProducts = (cartId: string | null, customerid: string) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!cartId) return;

    setLoading(true);
    api.get(`/app/v1/pos/shopping_cart/${cartId}`)
      .then((res) => {
        setProducts(res.data.result || []);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [cartId, customerid]);

  return { products, loading };
};
